import { DateTime } from 'luxon';

export default function getHumanReadableDiff(date) {
    if (isNaN(new Date(date).getTime())) {
        return '';
    }

    const givenDate = DateTime.fromISO(date);
    return givenDate.toRelative();
}